"use client";

import { c as _c } from "react/compiler-runtime";
import { RangeSlider as MantineRangeSlider } from "@mantine/core";
import styles from "./range-slider.module.css";
export type RangeSliderProps = Readonly<{
  value: readonly [number, number];
  onChange: (value: [number, number]) => void;
  onChangeEnd?: (value: [number, number]) => void;
  min: number;
  max: number;
  step?: number;
  disabled?: boolean;
  thumbLabel?: string;
}>;
export function RangeSlider(t0) {
  const $ = _c(22);
  const {
    value,
    onChange,
    onChangeEnd,
    min,
    max,
    step,
    disabled: t1,
    thumbLabel
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== value) {
    t2 = [...value];
    $[0] = value;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      root: styles.root,
      thumb: styles.thumb,
      track: styles.track
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== disabled || $[4] !== max || $[5] !== min || $[6] !== onChange || $[7] !== onChangeEnd || $[8] !== step || $[9] !== t2 || $[10] !== thumbLabel) {
    t4 = <MantineRangeSlider min={min} max={max} step={step} value={t2} onChange={onChange} onChangeEnd={onChangeEnd} disabled={disabled} thumbFromLabel={thumbLabel} thumbToLabel={thumbLabel} label={null} thumbSize={20} classNames={t3} />;
    $[3] = disabled;
    $[4] = max;
    $[5] = min;
    $[6] = onChange;
    $[7] = onChangeEnd;
    $[8] = step;
    $[9] = t2;
    $[10] = thumbLabel;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== value[0]) {
    t5 = <span className={styles.valueLabel}>{value[0]}</span>;
    $[12] = value[0];
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== value[1]) {
    t6 = <span className={styles.valueLabel}>{value[1]}</span>;
    $[14] = value[1];
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t5 || $[17] !== t6) {
    t7 = <div className={styles.valueLabels} aria-hidden={true}>{t5}{t6}</div>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t4 || $[20] !== t7) {
    t8 = <div className={styles.wrapper}>{t4}{t7}</div>;
    $[19] = t4;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}